import React, { useEffect, useState,forwardRef,useImperativeHandle } from "react";
import "./BillList.css"; // Linked CSS file for styling
import logo from "../assets/images/logo.png"; // Adjust the path based on the file's location
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { message } from "antd";
import axios from "axios";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import config from "../config";
import { take } from "lodash";

const Invoice = forwardRef( ({ orders, dataTaxes }, ref) => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const apiEndUserBaseUrl = config.REACT_APP_ENDUSER_API_BASE_URL;
  const [imageLogo, setImageLogo] = useState(null);
  const [restaurantName, setRestaurantName] = useState(null);
  const [restaurantAddress, setRestaurantAddress] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);

  const getSetting = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/settings/get-settings`
      );

      if (data && data.image) {
        setImageLogo(data.image);
        setRestaurantName(data.name);
        setRestaurantAddress(data.address);
      } else {
        setImageLogo(
          "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png"
        );
        setRestaurantName("Klang Bak Kut Teh");
        setRestaurantAddress("Address");
      }
    } catch (error) {
      message.error("Something Went Wrong");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId);

        if (window.location.pathname === "/login") {
          navigate("/");
        }
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, [navigate]);

  // expose the print method
      useImperativeHandle(ref, () => ({
        printReceipt: async () => {
         await sendReceiptToBackend();
        },
      }));

  if (!orders || !orders.orderDetails) {
    return <div>No order details available for receipt.</div>;
  }

  

  // Extracting relevant details with fallback values
  const {
    cashierName,
    date,
    invoiceId,
    orderDetails,
    billAmount,
    method,
    paid,
    balance,
    pax,
    remarks,
    tableNo,
    takeAway,
    transactionId,
  } = orders;

  console.log("orders in line 95:", orders);

  // Calculating the totals
  const orderItems = orderDetails
    .flatMap((order) => Array.isArray(order.order_items) ? order.order_items : [])
    .sort((a, b) => {
      const getSortValue = (item) => {
        const val = item.product?.discountAble;
        if (val === false) return 0;
        return 1;
      };
      return getSortValue(b) - getSortValue(a);
    });
    
  const sendReceiptToBackend = async () => {
    const selectedPrinterId = localStorage.getItem("selectedPrinterId");
    const payload = {
      logo: imageLogo,
      resName: restaurantName,
      address: restaurantAddress,
      tableNumber: tableNo,
      invoiceId,
      cashierName: currentUser,
      items: consolidateItems(orderDetails),
      paymentMethod: method,
      cashAmount: method === "Cash" ? (parseFloat(billAmount?.payableAmount) || 0).toFixed(2) : null,
      change:
        method === "Cash" ? Math.max(0, parseFloat(balance)).toFixed(2) : null,
      remarks,
      selectedPrinterId: selectedPrinterId,
      grandTotal: (parseFloat(billAmount?.grandTotal) || 0).toFixed(2),
      taxes: billAmount.taxes,
      deposits:
        {
          haveDeposit: Number(billAmount.deposit?.amount) > 0,
          amount: billAmount.deposit?.amount,
          method: billAmount.deposit?.method,
          payable: (parseFloat(billAmount?.payableAmount) || 0).toFixed(2),
        },
      
      services: billAmount.services,
      takeAwayTable: takeAway,
      total: (parseFloat(billAmount?.total) || 0).toFixed(2),
      discount: (parseFloat(billAmount?.discount) || 0).toFixed(2),
      discountAmount : billAmount?.discountAmount,
      discountType: billAmount?.discountType,
      subTotal: (parseFloat(billAmount?.subTotal) || 0).toFixed(2),
      grandTotalBeforeRounding: (parseFloat(billAmount?.grandTotalBeforeRounding) || 0).toFixed(2),
      roundingAmount: (parseFloat(billAmount?.rounding) || 0).toFixed(2),
      transactionId,
      url: apiEndUserBaseUrl,
      _id: orders._id, // Pass the order ID for backend processing
    };
    console.log("payload", payload);

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/printreceipt`,
        payload
      );
      if (response.data.success) {
        message.success("Receipt Print successfully!");
      } else {
        message.error(
          response.data.message || "Failed to print receipt."
        );
        throw new Error(
          response.data.message || "Failed to print receipt."
        );
      }
    } catch (error) {
      console.error("Error sending receipt to backend:", error);
      message.error("Something went wrong for print recept.");
    }
  };

  // Function to consolidate items
  const consolidateItems = (orderDetails) => {
    const itemMap = new Map();
    orderDetails
      .flatMap((order) => order.order_items)
      .forEach((item) => {
        const productName = item.product.name;
        // const discountAble = item.product.discountAble;
        const remarks = item.remarks || "";
        const addOns = item.product.addOns.map((addOn) => ({
          name: addOn.name,
          price: addOn.price,
        }));
        // Calculate total add-ons price
        let addOnsTotalPrice = 0;
        if (item.product.category === "Combo") {
          // For combo items: only add prices for custom options (from empty groups)
          addOnsTotalPrice = item.product.addOns.reduce((sum, addOn) => {
            const isCustomOption = addOn.isCategoryItem ? false : (addOn.id && !addOn._id);
            return isCustomOption ? sum + Number(addOn.price) : sum;
          }, 0);
        } else {
          // For regular items, add all add-on prices
          addOnsTotalPrice = addOns.reduce(
            (sum, addOn) => sum + Number(addOn.price),
            0
          );
        }

        // Generate a unique key based on product name, remarks, and sorted add-ons
        const addOnKey = addOns
          .map((addOn) => addOn.name)
          .sort()
          .join(",");
        const uniqueKey = `${productName}|${remarks}|${addOnKey}`;

        // Calculate item total including add-ons price
        const itemTotalPrice = (
          item.quantity *
          (item.product.price + addOnsTotalPrice)
        ).toFixed(2);

        if (itemMap.has(uniqueKey)) {
          // If item exists, update quantity and total
          const existingItem = itemMap.get(uniqueKey);
          existingItem.quantity += item.quantity;
          existingItem.total = (
            existingItem.quantity *
            (item.product.price + addOnsTotalPrice)
          ).toFixed(2);
        } else {
          // Otherwise, add new item
          itemMap.set(uniqueKey, {
            name: productName,
            // discountAble: discountAble,
            addOns,
            quantity: item.quantity,
            total: itemTotalPrice,
            remarks: remarks,
          });
        }
      });

    return Array.from(itemMap.values());
  };

  return (
    <div id="invoice-content" style={{ minWidth: "80mm" }}>
      <style>{`
                .receipt-container { font-family: Arial, sans-serif; max-width: 450px; margin: 20px auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9; }
                .receipt-header { text-align: center; margin-bottom: 20px; font-size:22px}
                .receipt-details { margin-bottom: 20px; line-height: 1.5; font-size:17px }
                .receipt-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                .receipt-table th, .receipt-table td { padding: 8px; border-bottom: 1px solid #ddd; font-size:17px}
                .receipt-row { display: flex; justify-content: space-between; font-size: 18px; font-family: Arial; margin: 5px 0; }
                .separator { text-align: right; margin: 10px 0; color: #999; }
                .receipt-footer { text-align: center; margin-top: 60px; color: #555; font-size: 11px; }
                .separator {text-align: right; margin: 5px 0; border-top: 1px dashed #000; height: 1px; width: 100%;}
            `}</style>
      <div className="receipt-container">
        <div className="receipt-header">
          {/* <img
            src={imageLogo}
            alt="Restaurant Logo"
            style={{ width: "250px", height: "120px", marginBottom: "10px" }}
          /> */}
          <p>
            <strong>Receipt</strong>
          </p>
          <p>
            <strong>{restaurantName}</strong>
          </p>
          <p style={{ fontSize: "18px",marginBottom:"0px" }}>
            <strong>{restaurantAddress?.addressLine1}</strong>
          </p>
          <p style={{ fontSize: "18px",marginBottom:"0px"}}>
            <strong>{restaurantAddress?.addressLine2}</strong>
          </p>
          <p style={{ fontSize: "18px",marginBottom:"0px" }}>
            <strong>{restaurantAddress?.postalCodeCity}</strong>
          </p>
          <p style={{ fontSize: "18px", paddingBottom: "15px",marginBottom:"0px" }}>
            <strong>{restaurantAddress?.stateCountry}</strong>
          </p>
        </div>

        <div className="receipt-details">
          <p>
            <strong>Invoice ID:</strong> {invoiceId}
          </p>
          <p>
            <strong>Table Number:</strong> {tableNo}
          </p>
          <p>
            <strong>Date:</strong> {new Date(date).toLocaleString()}
          </p>
          <p>
            <strong>Cashier:</strong> {cashierName}
          </p>
        </div>

        <table className="receipt-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th style={{ textAlign: "right" }}>Total ({symbol})</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(
              orderItems.reduce((acc, item) => {
                // Use a composite key combining productName and remark
                const key = `${item?.product.name || ""}-${
                  item?.remarks || ""
                }-${item?.product.addOns || []}`;

                acc[key] = acc[key] || {
                  productName: item?.product.name || "",
                  addOns: item?.product.addOns || [],
                  remark: item?.remarks || "",
                  totalQuantity: 0,
                  discountAble: Boolean(item?.product.discountAble !== false),
                  price: Number(item?.product.price || 0),
                };

                acc[key].totalQuantity += Number(item?.quantity || 0);

                return acc;
              }, {})
            ).map(
              (
                [
                  key,
                  {
                    productName,
                    remark,
                    discountAble,
                    totalQuantity,
                    price,
                    addOns,
                  },
                ],
                index
              ) => (
                <React.Fragment key={index}>
                  <tr key={index}>
                    <td>
                      {productName} {discountAble ? "" : "*"}
                      <div style={{ paddingLeft: "20px" }}>
                        {Array.isArray(addOns) && addOns.length > 0 && (
                          <ul
                            style={{
                              listStyleType: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            {Object.entries(
                              addOns.reduce((acc, addOn) => {
                                if (!acc[addOn.group]) {
                                  acc[addOn.group] = {
                                    names: [],
                                    totalPrice: 0,
                                  };
                                }

                                acc[addOn.group].names.push(addOn.name);

                                // Add formatted price and log the updated accumulator
                                acc[addOn.group].totalPrice += parseFloat(
                                  addOn.price
                                );
                                return acc;
                              }, {})
                            ).map(([groupName, { names, totalPrice }], idx) => (
                              <li key={idx}>
                                - {names.join(", ")} (+
                                {totalPrice.toFixed(2)})
                                {console.log(
                                  `Group: ${groupName}, Names: ${names.join(
                                    ", "
                                  )}, Total Price: ${totalPrice.toFixed(2)}`
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                        {remark && (
                          <div style={{ fontStyle: "italic" }}>
                            {" "}
                            -Remark: {remark}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>{totalQuantity}</td>
                    <td style={{ textAlign: "right" }}>
                      {/* First, sum the formatted add-on prices */}
                      {(
                        (Object.values(addOns).reduce((total, addOn) => {
                          const formattedPrice = parseFloat(
                            addOn.price
                          ).toFixed(2); // Format each add-on price
                          return total + parseFloat(formattedPrice); // Add formatted price to the total
                        }, 0) +
                          price) *
                        totalQuantity
                      ).toFixed(2)}{" "}
                      {/* Apply toFixed on the final total */}
                    </td>
                  </tr>
                </React.Fragment>
              )
            )}

            {(() => {
              const filteredServices = billAmount.services.filter(
                (service) =>
                  service.for_take_away === takeAway && service.quantity > 0
              );
              if (filteredServices.length === 0) return null;

              return filteredServices.map((service, index) => (
                <tr key={index}>
                  <td>{service.name} **</td>
                  <td>{service.quantity}</td>
                  <td style={{ textAlign: "right" }}>{service.totalPrice}</td>
                </tr>
              ));
            })()}
          </tbody>
        </table>

        <div className="receipt">
          <div className="receipt-row">
            <span className="label">Total:</span>
            <span className="value">{billAmount.total}</span>
          </div>
          <div className="receipt-row">
            <span>Discount { billAmount.discountType == '%' ? "(" + billAmount?.discountAmount + billAmount?.discountType + ")" : ""}:</span>
            <span>{parseFloat(billAmount?.discount).toFixed(2)}</span>
          </div>
          <div className="receipt-row">
            <span>Subtotal:</span>
            <span>{billAmount.subTotal}</span>
          </div>
          {billAmount.taxes &&
            billAmount.taxes.length > 0 &&
            billAmount.taxes.map((tax, index) => {
              console.log('tax in line 438:',tax)
              const shouldApplyTax =
                !takeAway || (takeAway && tax.taxValidForTakeAway);
              const displayedRate = shouldApplyTax ? tax.taxRate : "0%";

              return (
                <div className="receipt-row" key={index}>
                  <span>
                    {tax.taxName} ({displayedRate}):
                  </span>
                  <span>{tax.taxAmount}</span>
                </div>
              );
            })}
          <div className="receipt-row">
            <span>Pre-Rounding Total:</span>
            <span>{billAmount.grandTotalBeforeRounding}</span>
          </div>
          <div className="receipt-row">
            <span>Rounding:</span>
            <span>
              {billAmount.rounding < 0
                ? `- ${Math.abs(billAmount.rounding).toFixed(2)}`
                : `${billAmount.rounding}`}
            </span>
          </div>
          <div className="separator"></div>
          <div className="receipt-row">
            <span style={{ fontSize: "25px" }}>
              <strong>Grand Total:</strong>
            </span>
            <span style={{ fontSize: "25px" }}>
              <strong>{billAmount.grandTotal}</strong>
            </span>
          </div>
          {billAmount.deposit.haveDeposit === true && (
            <>
              <div className="receipt-row receipt-total">
                <span className="label" style={{ fontSize: "18px" }}>
                  Deposit:
                </span>
                <span className="value" style={{ fontSize: "18px" }}>
                  {billAmount.deposit.amount}
                </span>
              </div>
              <div className="receipt-row receipt-total">
                <span className="label" style={{ fontSize: "18px" }}>
                  Payable Amount:
                </span>
                <span className="value" style={{ fontSize: "18px" }}>
                  {billAmount.payableAmount}
                </span>
              </div>
              <div className="receipt-row receipt-total">
                <span className="label" style={{ fontSize: "18px" }}>
                  Deposit Method:
                </span>
                <span className="value" style={{ fontSize: "18px" }}>
                  {[billAmount.deposit.method]}
                </span>
              </div>
            </>
          )}
          {method === "Cash" && (
            <>
              <div className="receipt-row">
                <span>
                  <strong>Cash:</strong>
                </span>
                <span>
                  <strong>{(billAmount.payableAmount || 0)}</strong>
                </span>
              </div>

              <div className="receipt-row">
                <span>
                  <strong>Change:</strong>
                </span>
                <span>
                  <strong>{(balance || 0)}</strong>
                </span>
              </div>
              <div className="separator"></div>
            </>
          )}
          {method !== "Cash" && (
            <>
              <div className="receipt-row">
                <span>
                  <strong>Payment Method:</strong>
                </span>
                <span>
                  <strong>{[method] || method}</strong>
                </span>
              </div>
              <div className="receipt-row">
                <span>
                  <strong>Transaction ID:</strong>
                </span>
                <span>
                  <strong>{transactionId}</strong>
                </span>
              </div>
              <div className="separator"></div>
            </>
          )}
          {remarks && (
            <div className="receipt-row">
              <span>Remarks:</span>
              <span>{remarks}</span>
            </div>
          )}
        </div>

        <div className="receipt-footer">
          <p>
            Items marked with * are <strong>not eligible</strong> for percentage
            discount.
          </p>
          <p>
            Service items marked with ** are <strong>only added</strong> at the
            Grand Total.
          </p>
          <p>Thank you! Please come again :)</p>
        </div>
      </div>
      {/* <div style={{ textAlign: "right", marginTop: "20px" }}>
        <button
          onClick={sendReceiptToBackend}
          className="ant-btn ant-btn-primary"
        >
          Print Receipt
        </button>
      </div> */}
    </div>
  );
}
)

export default Invoice;
